module.exports = __webpack_public_path__ + "static/media/blobecoin_transparent_small.ed982b61.png";